import { User, UserOverview, UserCreate } from 'projects/access-gui/views/users'

module.exports = [
  {
    path: '/users',
    exact: true,
    component: UserOverview,
    admin: true
  },
  {
    path: '/users/create',
    exact: true,
    component: UserCreate,
    admin: true
  },
  {
    path: '/users/:userid',
    exact: true,
    component: User
  }
]



// WEBPACK FOOTER //
// ./src/projects/access-gui/routes/users.js